<template>
    <div class="form flex">
        <div class="form-field">
            <label class="form-field-label">{{ label }}</label>

            <input
                   type="text"
                   :value="pathText"
                   @change="savePath"
            >

            <span v-if="error" class="error-text">Field data is not correct</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ExportFormField",

        emits: [
            'setPath',
        ],

        props: [
            'label',
            'pathText',
            'error',
        ],

        methods: {
            savePath(e) {
                let value = e.target.value.trim();

                this.$emit('setPath', value);
            },

        },

    }
</script>

<style scoped>
    .form {
        margin: 0 0 15px;
    }

    .flex {
        align-items: flex-end;
    }

    .form-field {
        position: relative;
        width: 100%;
        /*margin: 0 10px;*/
    }

    .form-field-label {
        display: inline-block;
    }

    .error-text {
        font-size: 14px;
    }
</style>